Ext.define('SA.data.EntityCache', {
    extractResultsFromQueryResponse: Ext.identityFn,
    toId: Ext.identityFn,

    batchSize: 1000,

    constructor() {
        SA.Observable.apply(this);

        this.cache = {};
        this.callbacks = new SA.data.CallbackSet();
        this.pending = {};
    },

    add(result) {
        this.cache[result[this.idField]] = result;
    },

    get(ids, fn, scope) {
        var pending = this.pending,
            single = !Array.isArray(ids),
            callbacks = this.callbacks,
            missing = false,
            entries;

        if (!ids) {
            return null;
        }

        if (single) {
            ids = [ids];
        }

        entries = ids.map(id => {
            id = this.toId(id);

            var entry = this.getImpl(id);

            if (!entry) {
                missing = true;

                if (entry == null) {
                    pending[id] = true;
                }
            }

            return entry;
        });

        if (missing) {
            callbacks.add(fn, scope);

            if (!this.timer) {
                this.timer = setTimeout(this.load.bind(this), 1);
            }
        }

        return single ? entries[0] : entries;
    },

    getBatchSize() {
        return this.batchSize;
    },

    getImpl(id) {
        return this.cache[id];
    },

    getPromise(ids) {
        var get = fn => this.get(ids, fn);

        return new Promise(resolve => {
            maybeResolve();

            function maybeResolve() {
                var result = get();

                if (Ext.Array.from(result).every(item => !!item)) {
                    resolve(result);
                    return;
                }

                get(maybeResolve);
            }
        });
    },

    async load() {
        var {batchSize, cache} = this,
            ids = Object.keys(this.pending),
            idBatches = SA.Array.divide(ids, batchSize);

        this.timer = null;

        if (ids.length === 0) {
            return;
        }

        ids.forEach(id => cache[id] = false); 

        this.pending = {};

        await Promise.all(idBatches.map(idBatch => new Promise(resolve => {
            var query = SA.data.Query.from({...this.buildQuery(idBatch), limit: batchSize});

            query.addFailure(() => resolve([]));
            query.addSuccess(results => resolve(this.extractResultsFromQueryResponse(results).filter(entity => !!entity)));

            query.run();
        }))).then(entityBatches => {
            var entities = entityBatches.flat();

            if (entities.length) {
                entities.forEach(this.add, this);

                this.runCallbacks();
            }

            if (entities.length < ids.length) {


                                this.fireEvent('missingEntities');
            }
        });
    },

    runCallbacks() {
        this.callbacks.run();
    }
});